import {createSelector} from 'reselect';
import SpotUtils from 'utils/spot';
import {
    initialReservationTypes,
    setAmenities,
    setReservationTypes,
} from './filters-utils';

const getSearchId = state => state.searchRequest.id;
const getIsMonthly = state => state.searchRequest.monthly;
const getAllSpots = state => state.spots.data;
const getCurrentFilters = state => state.filters;
const getAllReservationTypes = state => state.filters.reservationTypes;
let currentSearchId = null;

export const getAmenities = createSelector(
    [getSearchId, getIsMonthly, getAllSpots, getCurrentFilters],
    (searchId, isMonthly, spots, filters) => {
        if (!spots.length) {
            return {};
        }

        const isNewSearch = currentSearchId !== searchId;

        if (isNewSearch) {
            currentSearchId = searchId;
        }

        return setAmenities({
            spots: SpotUtils.filter(spots, filters, isMonthly),
            rateType: isMonthly ? 'monthly_rates' : 'hourly_rates',
            isNewSearch,
        });
    }
);

export const getReservationTypes = createSelector(
    [getIsMonthly, getAllSpots, getCurrentFilters, getAllReservationTypes],
    (isMonthly, spots, filters, reservationTypes) => {
        if (!spots.length || !isMonthly) {
            return initialReservationTypes;
        }

        return setReservationTypes({
            spots: SpotUtils.filter(spots, filters, isMonthly),
            reservationTypes,
        });
    }
);
